// Data taken from:
// https://learn.microsoft.com/en-us/azure/ai-services/language-service/personally-identifiable-information/concepts/entity-categories
// and https://github.com/Azure/azure-sdk-for-js/blob/ec8f19581c620fc003f035bc29cdca2e58592b29/sdk/cognitivelanguage/ai-language-text/review/ai-language-text.api.md?plain=1#L559

import { TFunction } from "i18next";

export const getPIICategories = (t: TFunction) => [
  {
    value: "Age",
    label: t("dlp_page.pii_categories.Age"),
  },
  {
    value: "Email",
    label: t("dlp_page.pii_categories.Email"),
  },
  {
    value: "Date",
    label: t("dlp_page.pii_categories.Date"),
  },
  {
    value: "Organization",
    label: t("dlp_page.pii_categories.Organization"),
  },
  {
    value: "Person",
    label: t("dlp_page.pii_categories.Person"),
  },
  {
    value: "PhoneNumber",
    label: t("dlp_page.pii_categories.PhoneNumber"),
  },
  {
    value: "Address",
    label: t("dlp_page.pii_categories.Address"),
  },
  {
    value: "IPAddress",
    label: t("dlp_page.pii_categories.IPAddress"),
  },
  {
    value: "URL",
    label: t("dlp_page.pii_categories.URL"),
  },
  {
    value: "CreditCardNumber",
    label: t("dlp_page.pii_categories.CreditCardNumber"),
  },
  {
    value: "SwiftCode",
    label: t("dlp_page.pii_categories.SwiftCode"),
  },
  {
    value: "InternationalBankingAccountNumber",
    label: t("dlp_page.pii_categories.InternationalBankingAccountNumber"),
  },
  {
    value: "ABARoutingNumber",
    label: t("dlp_page.pii_categories.ABARoutingNumber"),
  },
  {
    value: "ARNationalIdentityNumber",
    label: t("dlp_page.pii_categories.ARNationalIdentityNumber"),
  },
  {
    value: "ATIdentityCard",
    label: t("dlp_page.pii_categories.ATIdentityCard"),
  },
  {
    value: "ATTaxIdentificationNumber",
    label: t("dlp_page.pii_categories.ATTaxIdentificationNumber"),
  },
  {
    value: "ATValueAddedTaxNumber",
    label: t("dlp_page.pii_categories.ATValueAddedTaxNumber"),
  },
  {
    value: "AUBankAccountNumber",
    label: t("dlp_page.pii_categories.AUBankAccountNumber"),
  },
  {
    value: "AUBusinessNumber",
    label: t("dlp_page.pii_categories.AUBusinessNumber"),
  },
  {
    value: "AUCompanyNumber",
    label: t("dlp_page.pii_categories.AUCompanyNumber"),
  },
  {
    value: "AUDriversLicenseNumber",
    label: t("dlp_page.pii_categories.AUDriversLicenseNumber"),
  },
  {
    value: "AUMedicalAccountNumber",
    label: t("dlp_page.pii_categories.AUMedicalAccountNumber"),
  },
  {
    value: "AUPassportNumber",
    label: t("dlp_page.pii_categories.AUPassportNumber"),
  },
  {
    value: "AUTaxFileNumber",
    label: t("dlp_page.pii_categories.AUTaxFileNumber"),
  },
  {
    value: "AzureDocumentDBAuthKey",
    label: t("dlp_page.pii_categories.AzureDocumentDBAuthKey"),
  },
  {
    value: "AzureIaasDatabaseConnectionAndSQLString",
    label: t("dlp_page.pii_categories.AzureIaasDatabaseConnectionAndSQLString"),
  },
  {
    value: "AzureIoTConnectionString",
    label: t("dlp_page.pii_categories.AzureIoTConnectionString"),
  },
  {
    value: "AzurePublishSettingPassword",
    label: t("dlp_page.pii_categories.AzurePublishSettingPassword"),
  },
  {
    value: "AzureRedisCacheString",
    label: t("dlp_page.pii_categories.AzureRedisCacheString"),
  },
  {
    value: "AzureSAS",
    label: t("dlp_page.pii_categories.AzureSAS"),
  },
  {
    value: "AzureServiceBusString",
    label: t("dlp_page.pii_categories.AzureServiceBusString"),
  },
  {
    value: "AzureStorageAccountGeneric",
    label: t("dlp_page.pii_categories.AzureStorageAccountGeneric"),
  },
  {
    value: "AzureStorageAccountKey",
    label: t("dlp_page.pii_categories.AzureStorageAccountKey"),
  },
  {
    value: "BENationalNumber",
    label: t("dlp_page.pii_categories.BENationalNumber"),
  },
  {
    value: "BENationalNumberV2",
    label: t("dlp_page.pii_categories.BENationalNumberV2"),
  },
  {
    value: "BEValueAddedTaxNumber",
    label: t("dlp_page.pii_categories.BEValueAddedTaxNumber"),
  },
  {
    value: "BGUniformCivilNumber",
    label: t("dlp_page.pii_categories.BGUniformCivilNumber"),
  },
  {
    value: "BrcpfNumber",
    label: t("dlp_page.pii_categories.BrcpfNumber"),
  },
  {
    value: "BRLegalEntityNumber",
    label: t("dlp_page.pii_categories.BRLegalEntityNumber"),
  },
  {
    value: "BRNationalIdrg",
    label: t("dlp_page.pii_categories.BRNationalIdrg"),
  },
  {
    value: "CABankAccountNumber",
    label: t("dlp_page.pii_categories.CABankAccountNumber"),
  },
  {
    value: "CADriversLicenseNumber",
    label: t("dlp_page.pii_categories.CADriversLicenseNumber"),
  },
  {
    value: "CAHealthServiceNumber",
    label: t("dlp_page.pii_categories.CAHealthServiceNumber"),
  },
  {
    value: "CAPassportNumber",
    label: t("dlp_page.pii_categories.CAPassportNumber"),
  },
  {
    value: "CAPersonalHealthIdentification",
    label: t("dlp_page.pii_categories.CAPersonalHealthIdentification"),
  },
  {
    value: "CASocialInsuranceNumber",
    label: t("dlp_page.pii_categories.CASocialInsuranceNumber"),
  },
  {
    value: "CHSocialSecurityNumber",
    label: t("dlp_page.pii_categories.CHSocialSecurityNumber"),
  },
  {
    value: "CLIdentityCardNumber",
    label: t("dlp_page.pii_categories.CLIdentityCardNumber"),
  },
  {
    value: "CNResidentIdentityCardNumber",
    label: t("dlp_page.pii_categories.CNResidentIdentityCardNumber"),
  },
  {
    value: "CYIdentityCard",
    label: t("dlp_page.pii_categories.CYIdentityCard"),
  },
  {
    value: "CYTaxIdentificationNumber",
    label: t("dlp_page.pii_categories.CYTaxIdentificationNumber"),
  },
  {
    value: "CZPersonalIdentityNumber",
    label: t("dlp_page.pii_categories.CZPersonalIdentityNumber"),
  },
  {
    value: "CZPersonalIdentityV2",
    label: t("dlp_page.pii_categories.CZPersonalIdentityV2"),
  },
  {
    value: "DEDriversLicenseNumber",
    label: t("dlp_page.pii_categories.DEDriversLicenseNumber"),
  },
  {
    value: "DEIdentityCardNumber",
    label: t("dlp_page.pii_categories.DEIdentityCardNumber"),
  },
  {
    value: "DEPassportNumber",
    label: t("dlp_page.pii_categories.DEPassportNumber"),
  },
  {
    value: "DETaxIdentificationNumber",
    label: t("dlp_page.pii_categories.DETaxIdentificationNumber"),
  },
  {
    value: "DEValueAddedNumber",
    label: t("dlp_page.pii_categories.DEValueAddedNumber"),
  },
  {
    value: "DKPersonalIdentificationNumber",
    label: t("dlp_page.pii_categories.DKPersonalIdentificationNumber"),
  },
  {
    value: "DKPersonalIdentificationV2",
    label: t("dlp_page.pii_categories.DKPersonalIdentificationV2"),
  },
  {
    value: "DrugEnforcementAgencyNumber",
    label: t("dlp_page.pii_categories.DrugEnforcementAgencyNumber"),
  },
  {
    value: "DrugEnforcementAgencyNumber",
    label: t("dlp_page.pii_categories.DrugEnforcementAgencyNumber"),
  },
  {
    value: "EEPersonalIdentificationCode",
    label: t("dlp_page.pii_categories.EEPersonalIdentificationCode"),
  },
  {
    value: "Esdni",
    label: t("dlp_page.pii_categories.Esdni"),
  },
  {
    value: "PeruDni",
    label: t("dlp_page.pii_categories.PeruDni"),
  },
  {
    value: "ESSocialSecurityNumber",
    label: t("dlp_page.pii_categories.ESSocialSecurityNumber"),
  },
  {
    value: "ESTaxIdentificationNumber",
    label: t("dlp_page.pii_categories.ESTaxIdentificationNumber"),
  },
  {
    value: "EUDebitCardNumber",
    label: t("dlp_page.pii_categories.EUDebitCardNumber"),
  },
  {
    value: "EUDriversLicenseNumber",
    label: t("dlp_page.pii_categories.EUDriversLicenseNumber"),
  },
  {
    value: "EugpsCoordinates",
    label: t("dlp_page.pii_categories.EugpsCoordinates"),
  },
  {
    value: "EUNationalIdentificationNumber",
    label: t("dlp_page.pii_categories.EUNationalIdentificationNumber"),
  },
  {
    value: "EUPassportNumber",
    label: t("dlp_page.pii_categories.EUPassportNumber"),
  },
  {
    value: "EUSocialSecurityNumber",
    label: t("dlp_page.pii_categories.EUSocialSecurityNumber"),
  },
  {
    value: "EUTaxIdentificationNumber",
    label: t("dlp_page.pii_categories.EUTaxIdentificationNumber"),
  },
  {
    value: "FIEuropeanHealthNumber",
    label: t("dlp_page.pii_categories.FIEuropeanHealthNumber"),
  },
  {
    value: "FINationalID",
    label: t("dlp_page.pii_categories.FINationalID"),
  },
  {
    value: "FINationalIDV2",
    label: t("dlp_page.pii_categories.FINationalIDV2"),
  },
  {
    value: "FIPassportNumber",
    label: t("dlp_page.pii_categories.FIPassportNumber"),
  },
  {
    value: "FRDriversLicenseNumber",
    label: t("dlp_page.pii_categories.FRDriversLicenseNumber"),
  },
  {
    value: "FRHealthInsuranceNumber",
    label: t("dlp_page.pii_categories.FRHealthInsuranceNumber"),
  },
  {
    value: "FRNationalID",
    label: t("dlp_page.pii_categories.FRNationalID"),
  },
  {
    value: "FRPassportNumber",
    label: t("dlp_page.pii_categories.FRPassportNumber"),
  },
  {
    value: "FRSocialSecurityNumber",
    label: t("dlp_page.pii_categories.FRSocialSecurityNumber"),
  },
  {
    value: "FRTaxIdentificationNumber",
    label: t("dlp_page.pii_categories.FRTaxIdentificationNumber"),
  },
  {
    value: "FRValueAddedTaxNumber",
    label: t("dlp_page.pii_categories.FRValueAddedTaxNumber"),
  },
  {
    value: "GRNationalIDCard",
    label: t("dlp_page.pii_categories.GRNationalIDCard"),
  },
  {
    value: "GRNationalIDV2",
    label: t("dlp_page.pii_categories.GRNationalIDV2"),
  },
  {
    value: "GRTaxIdentificationNumber",
    label: t("dlp_page.pii_categories.GRTaxIdentificationNumber"),
  },
  {
    value: "HKIdentityCardNumber",
    label: t("dlp_page.pii_categories.HKIdentityCardNumber"),
  },
  {
    value: "HRIdentityCardNumber",
    label: t("dlp_page.pii_categories.HRIdentityCardNumber"),
  },
  {
    value: "HRNationalIDNumber",
    label: t("dlp_page.pii_categories.HRNationalIDNumber"),
  },
  {
    value: "HRPersonalIdentificationNumber",
    label: t("dlp_page.pii_categories.HRPersonalIdentificationNumber"),
  },
  {
    value: "HRPersonalIdentificationOIBNumberV2",
    label: t("dlp_page.pii_categories.HRPersonalIdentificationOIBNumberV2"),
  },
  {
    value: "HUPersonalIdentificationNumber",
    label: t("dlp_page.pii_categories.HUPersonalIdentificationNumber"),
  },
  {
    value: "HUTaxIdentificationNumber",
    label: t("dlp_page.pii_categories.HUTaxIdentificationNumber"),
  },
  {
    value: "HUValueAddedNumber",
    label: t("dlp_page.pii_categories.HUValueAddedNumber"),
  },
  {
    value: "IDIdentityCardNumber",
    label: t("dlp_page.pii_categories.IDIdentityCardNumber"),
  },
  {
    value: "IEPersonalPublicServiceNumber",
    label: t("dlp_page.pii_categories.IEPersonalPublicServiceNumber"),
  },
  {
    value: "IEPersonalPublicServiceNumberV2",
    label: t("dlp_page.pii_categories.IEPersonalPublicServiceNumberV2"),
  },
  {
    value: "ILBankAccountNumber",
    label: t("dlp_page.pii_categories.ILBankAccountNumber"),
  },
  {
    value: "ILNationalID",
    label: t("dlp_page.pii_categories.ILNationalID"),
  },
  {
    value: "INPermanentAccount",
    label: t("dlp_page.pii_categories.INPermanentAccount"),
  },
  {
    value: "INUniqueIdentificationNumber",
    label: t("dlp_page.pii_categories.INUniqueIdentificationNumber"),
  },
  {
    value: "ITDriversLicenseNumber",
    label: t("dlp_page.pii_categories.ITDriversLicenseNumber"),
  },
  {
    value: "ITFiscalCode",
    label: t("dlp_page.pii_categories.ITFiscalCode"),
  },
  {
    value: "ITValueAddedTaxNumber",
    label: t("dlp_page.pii_categories.ITValueAddedTaxNumber"),
  },
  {
    value: "JPBankAccountNumber",
    label: t("dlp_page.pii_categories.JPBankAccountNumber"),
  },
  {
    value: "JPDriversLicenseNumber",
    label: t("dlp_page.pii_categories.JPDriversLicenseNumber"),
  },
  {
    value: "JPMyNumberCorporate",
    label: t("dlp_page.pii_categories.JPMyNumberCorporate"),
  },
  {
    value: "JPMyNumberPersonal",
    label: t("dlp_page.pii_categories.JPMyNumberPersonal"),
  },
  {
    value: "JPPassportNumber",
    label: t("dlp_page.pii_categories.JPPassportNumber"),
  },
  {
    value: "JPResidenceCardNumber",
    label: t("dlp_page.pii_categories.JPResidenceCardNumber"),
  },
  {
    value: "JPResidentRegistrationNumber",
    label: t("dlp_page.pii_categories.JPResidentRegistrationNumber"),
  },
  {
    value: "JPSocialInsuranceNumber",
    label: t("dlp_page.pii_categories.JPSocialInsuranceNumber"),
  },
  {
    value: "KRResidentRegistrationNumber",
    label: t("dlp_page.pii_categories.KRResidentRegistrationNumber"),
  },
  {
    value: "LTPersonalCode",
    label: t("dlp_page.pii_categories.LTPersonalCode"),
  },
  {
    value: "LUNationalIdentificationNumberNatural",
    label: t("dlp_page.pii_categories.LUNationalIdentificationNumberNatural"),
  },
  {
    value: "LUNationalIdentificationNumberNonNatural",
    label: t("dlp_page.pii_categories.LUNationalIdentificationNumberNonNatural"),
  },
  {
    value: "LVPersonalCode",
    label: t("dlp_page.pii_categories.LVPersonalCode"),
  },
  {
    value: "MTIdentityCardNumber",
    label: t("dlp_page.pii_categories.MTIdentityCardNumber"),
  },
  {
    value: "MTTaxIDNumber",
    label: t("dlp_page.pii_categories.MTTaxIDNumber"),
  },
  {
    value: "MYIdentityCardNumber",
    label: t("dlp_page.pii_categories.MYIdentityCardNumber"),
  },
  {
    value: "NLCitizensServiceNumber",
    label: t("dlp_page.pii_categories.NLCitizensServiceNumber"),
  },
  {
    value: "NLCitizensServiceNumberV2",
    label: t("dlp_page.pii_categories.NLCitizensServiceNumberV2"),
  },
  {
    value: "NLTaxIdentificationNumber",
    label: t("dlp_page.pii_categories.NLTaxIdentificationNumber"),
  },
  {
    value: "NLValueAddedTaxNumber",
    label: t("dlp_page.pii_categories.NLValueAddedTaxNumber"),
  },
  {
    value: "NOIdentityNumber",
    label: t("dlp_page.pii_categories.NOIdentityNumber"),
  },
  {
    value: "NZBankAccountNumber",
    label: t("dlp_page.pii_categories.NZBankAccountNumber"),
  },
  {
    value: "NZDriversLicenseNumber",
    label: t("dlp_page.pii_categories.NZDriversLicenseNumber"),
  },
  {
    value: "NZInlandRevenueNumber",
    label: t("dlp_page.pii_categories.NZInlandRevenueNumber"),
  },
  {
    value: "NZMinistryOfHealthNumber",
    label: t("dlp_page.pii_categories.NZMinistryOfHealthNumber"),
  },
  {
    value: "NZSocialWelfareNumber",
    label: t("dlp_page.pii_categories.NZSocialWelfareNumber"),
  },
  {
    value: "PHUnifiedMultiPurposeIDNumber",
    label: t("dlp_page.pii_categories.PHUnifiedMultiPurposeIDNumber"),
  },
  {
    value: "PLIdentityCard",
    label: t("dlp_page.pii_categories.PLIdentityCard"),
  },
  {
    value: "PLNationalID",
    label: t("dlp_page.pii_categories.PLNationalID"),
  },
  {
    value: "PLNationalIDV2",
    label: t("dlp_page.pii_categories.PLNationalIDV2"),
  },
  {
    value: "PLPassportNumber",
    label: t("dlp_page.pii_categories.PLPassportNumber"),
  },
  {
    value: "PlregonNumber",
    label: t("dlp_page.pii_categories.PlregonNumber"),
  },
  {
    value: "PLTaxIdentificationNumber",
    label: t("dlp_page.pii_categories.PLTaxIdentificationNumber"),
  },
  {
    value: "PTCitizenCardNumber",
    label: t("dlp_page.pii_categories.PTCitizenCardNumber"),
  },
  {
    value: "PTCitizenCardNumberV2",
    label: t("dlp_page.pii_categories.PTCitizenCardNumberV2"),
  },
  {
    value: "PTTaxIdentificationNumber",
    label: t("dlp_page.pii_categories.PTTaxIdentificationNumber"),
  },
  {
    value: "ROPersonalNumericalCode",
    label: t("dlp_page.pii_categories.ROPersonalNumericalCode"),
  },
  {
    value: "RUPassportNumberDomestic",
    label: t("dlp_page.pii_categories.RUPassportNumberDomestic"),
  },
  {
    value: "RUPassportNumberInternational",
    label: t("dlp_page.pii_categories.RUPassportNumberInternational"),
  },
  {
    value: "SANationalID",
    label: t("dlp_page.pii_categories.SANationalID"),
  },
  {
    value: "SENationalID",
    label: t("dlp_page.pii_categories.SENationalID"),
  },
  {
    value: "SENationalIDV2",
    label: t("dlp_page.pii_categories.SENationalIDV2"),
  },
  {
    value: "SEPassportNumber",
    label: t("dlp_page.pii_categories.SEPassportNumber"),
  },
  {
    value: "SETaxIdentificationNumber",
    label: t("dlp_page.pii_categories.SETaxIdentificationNumber"),
  },
  {
    value: "SGNationalRegistrationIdentityCardNumber",
    label: t("dlp_page.pii_categories.SGNationalRegistrationIdentityCardNumber"),
  },
  {
    value: "SITaxIdentificationNumber",
    label: t("dlp_page.pii_categories.SITaxIdentificationNumber"),
  },
  {
    value: "SIUniqueMasterCitizenNumber",
    label: t("dlp_page.pii_categories.SIUniqueMasterCitizenNumber"),
  },
  {
    value: "SKPersonalNumber",
    label: t("dlp_page.pii_categories.SKPersonalNumber"),
  },
  {
    value: "SQLServerConnectionString",
    label: t("dlp_page.pii_categories.SQLServerConnectionString"),
  },
  {
    value: "THPopulationIdentificationCode",
    label: t("dlp_page.pii_categories.THPopulationIdentificationCode"),
  },
  {
    value: "TRNationalIdentificationNumber",
    label: t("dlp_page.pii_categories.TRNationalIdentificationNumber"),
  },
  {
    value: "TWNationalID",
    label: t("dlp_page.pii_categories.TWNationalID"),
  },
  {
    value: "TWPassportNumber",
    label: t("dlp_page.pii_categories.TWPassportNumber"),
  },
  {
    value: "TWResidentCertificate",
    label: t("dlp_page.pii_categories.TWResidentCertificate"),
  },
  {
    value: "UAPassportNumberDomestic",
    label: t("dlp_page.pii_categories.UAPassportNumberDomestic"),
  },
  {
    value: "UAPassportNumberInternational",
    label: t("dlp_page.pii_categories.UAPassportNumberInternational"),
  },
  {
    value: "UKDriversLicenseNumber",
    label: t("dlp_page.pii_categories.UKDriversLicenseNumber"),
  },
  {
    value: "UKElectoralRollNumber",
    label: t("dlp_page.pii_categories.UKElectoralRollNumber"),
  },
  {
    value: "UKNationalHealthNumber",
    label: t("dlp_page.pii_categories.UKNationalHealthNumber"),
  },
  {
    value: "UKNationalInsuranceNumber",
    label: t("dlp_page.pii_categories.UKNationalInsuranceNumber"),
  },
  {
    value: "UKUniqueTaxpayerNumber",
    label: t("dlp_page.pii_categories.UKUniqueTaxpayerNumber"),
  },
  {
    value: "USBankAccountNumber",
    label: t("dlp_page.pii_categories.USBankAccountNumber"),
  },
  {
    value: "USDriversLicenseNumber",
    label: t("dlp_page.pii_categories.USDriversLicenseNumber"),
  },
  {
    value: "USIndividualTaxpayerIdentification",
    label: t("dlp_page.pii_categories.USIndividualTaxpayerIdentification"),
  },
  {
    value: "USSocialSecurityNumber",
    label: t("dlp_page.pii_categories.USSocialSecurityNumber"),
  },
  {
    value: "UsukPassportNumber",
    label: t("dlp_page.pii_categories.UsukPassportNumber"),
  },
  {
    value: "ZAIdentificationNumber",
    label: t("dlp_page.pii_categories.ZAIdentificationNumber"),
  },
  {
    value: "AuthToken",
    label: t("dlp_page.pii_categories.AuthToken"),
  },
  {
    value: "AwsCredentials",
    label: t("dlp_page.pii_categories.AwsCredentials"),
  },
  {
    value: "AzureAuthToken",
    label: t("dlp_page.pii_categories.AzureAuthToken"),
  },
  {
    value: "BasicAuthHeader",
    label: t("dlp_page.pii_categories.BasicAuthHeader"),
  },
  {
    value: "EncryptionKey",
    label: t("dlp_page.pii_categories.EncryptionKey"),
  },
  {
    value: "GcpApiKey",
    label: t("dlp_page.pii_categories.GcpApiKey"),
  },
  {
    value: "GcpCredentials",
    label: t("dlp_page.pii_categories.GcpCredentials"),
  },
  {
    value: "HttpCookie",
    label: t("dlp_page.pii_categories.HttpCookie"),
  },
  {
    value: "JsonWebToken",
    label: t("dlp_page.pii_categories.JsonWebToken"),
  },
  {
    value: "OauthClientSecret",
    label: t("dlp_page.pii_categories.OauthClientSecret"),
  },
  {
    value: "Password",
    label: t("dlp_page.pii_categories.Password"),
  },
  {
    value: "SslCertificate",
    label: t("dlp_page.pii_categories.SslCertificate"),
  },
  {
    value: "StorageSignedPolicyDocument",
    label: t("dlp_page.pii_categories.StorageSignedPolicyDocument"),
  },
  {
    value: "StorageSignedUrl",
    label: t("dlp_page.pii_categories.StorageSignedUrl"),
  },
  {
    value: "WeakPasswordHash",
    label: t("dlp_page.pii_categories.WeakPasswordHash"),
  },
  {
    value: "XsrfToken",
    label: t("dlp_page.pii_categories.XsrfToken"),
  },
  {
    value: "AiProviderApiKey",
    label: t("dlp_page.pii_categories.AiProviderApiKey"),
  },
  {
    value: "GitHubToken",
    label: t("dlp_page.pii_categories.GitHubToken"),
  },
  {
    value: "SlackWebhook",
    label: t("dlp_page.pii_categories.SlackWebhook"),
  },
  {
    value: "SlackToken",
    label: t("dlp_page.pii_categories.SlackToken"),
  },
];
